/* eslint-disable @typescript-eslint/no-explicit-any */
// define your typings for the store state
import type { ActionTree } from "vuex/types/index.js";
import eventBus from "@/event-bus";
import { Jsona } from "jsona";
import type { AxiosError } from "axios";
import {
  TRANSACTIONS_ORDERS_PAYMENT_STATUS_PAYED,
  TRANSACTIONS_ORDERS_PAYMENT_STATUS_PENDING,
  TRANSACTIONS_ORDERS_PAYMENT_STATUS_PARTIALLY_PAYED,
  VITE_OPENPAY_MERCHANT_ID,
  VITE_OPENPAY_PUBLIC_API_KEY,
  VITE_OPENPAY_IS_SANDBOX,
} from "@/config/constants";
import Transaction, { type ITransaction } from "@/models/Transaction";
import { CustomNotifyService } from "@/services/CustomNotifyService";
import { errorsToString } from "@/utils/general";
import type { BankCard } from "@/interfaces/BankCard";
import moment, { type Moment } from "moment";
import { loadScriptPaypal } from "@/utils/paypal";
import type { RouteLocationRaw } from "vue-router";
import type { StepCheckout } from "@/interfaces/StepCheckout";

const notifyService = new CustomNotifyService();

function showErrors(reason: AxiosError, message: string, time: number = 5000) {
  notifyService.getNotification({
    type: "error",
    title: `Ocurrio un error al procesar tu pedido`,
    text: errorsToString(reason) ?? message,
    time: time,
  });
}

const dataFormatter = new Jsona();

interface IPaymentMethod {
  code: string;
  tokenizer: boolean | null;
  secure_code_required: boolean | null;
  tokenizables: Array<BankCard>;
}

interface IPickupPerson {
  name: string;
  lastName: string;
  motherLastName: string;
  telephone: string;
}

export interface StateCheckoutTransaction {
  version: number;
  paymentMethodCode: null | string;
  paymentTokenizable: null | string;
  expiresTokenizable: null | Moment;
  isShipping: boolean | null;
  customerAddress: null | any;
  billingCustomerAddress: null | any;
  requiredBilling: boolean;
  store: null | any;
  pickupPerson: IPickupPerson;
  courier: null | any;
  paymentMethods: Array<IPaymentMethod>;
  monthlyPlans: Array<any>;
  monthlyPaymentOptions: Array<any>;
  hasMonthlyPayment: boolean;
  hasShippingInsurance: boolean;
  step: string;
  steps: Array<StepCheckout>;
  loading: boolean;
  acceptTerms: boolean;
  acceptShippingConditions: boolean;
  acceptPickupConditions: boolean;
  errorMessage: string | null;
  cvcValidate: string;
  paymentTokenizableTemporaly: BankCard[];
  deviceSessionId: string;
  trackingId: string;
  isSavingTransaction: boolean;
  transactionId: string | null;
}

const steps: Array<StepCheckout> = [
  {
    step: 1,
    code: "payment",
    title: "Pago",
    titleMobile: "Pago",
    to: { name: "cart-payment" },
    isValid: "isValidPayment",
    store: "storePayment",
    reset: "resetPayment",
    isCompleted: false,
    show: true,
  },
  {
    step: 2,
    code: "monthly-payment",
    title: "Mensualidades",
    titleMobile: "Mensualidades",
    to: { name: "cart-monthly" },
    isValid: "isValidMonthlyPayment",
    store: "storeMonthlyPayment",
    reset: "resetMonthlyPayment",
    isCompleted: false,
    show: true,
  },
  {
    step: 3,
    code: "review",
    title: "Detalles de mi orden",
    titleMobile: "Finalizar",
    to: { name: "cart-review" },
    isValid: "isValidReview",
    store: "",
    reset: "",
    isCompleted: false,
    show: true,
  },
];

export const defaultCheckoutTransactionInit = {
  version: 1.0,
  paymentMethodCode: null,
  paymentTokenizable: null,
  expiresTokenizable: null,
  isShipping: null,
  customerAddress: null,
  billingCustomerAddress: null,
  requiredBilling: false,
  store: null,
  pickupPerson: {
    name: "",
    lastName: "",
    motherLastName: "",
    telephone: "",
  },
  courier: null,
  paymentMethods: [],
  monthlyPlans: [],
  monthlyPaymentOptions: [],
  hasMonthlyPayment: false,
  hasShippingInsurance: true,
  step: "payment",
  steps: steps,
  loading: false,
  acceptTerms: false,
  acceptShippingConditions: false,
  cvcValidate: "",
  paymentTokenizableTemporaly: [],
  deviceSessionId: "",
  trackingId: "",
  isSavingTransaction: false,
  errorMessage: null,
  transactionId: null,
  acceptPickupConditions: false,
};

// export interface GetterCheckout {
//   getPaymentMethodCode(state: StateCheckoutTransaction): string | null;
//   getPaymentTokenizable(state: StateCheckoutTransaction): string | null;
//   getExpiresTokenizable(state: StateCheckoutTransaction): Moment | null;
//   getPaymentMethod(state: StateCheckoutTransaction): IPaymentMethod | null;
//   getSelectedPaymentTokenizable(state: StateCheckoutTransaction): BankCard | null;
//   getPaymentMethods(state: StateCheckoutTransaction): Array<IPaymentMethod>;
//   getCustomerAddress(state: StateCheckoutTransaction): any;
//   getBillingCustomerAddress(state: StateCheckoutTransaction): any;
//   getIsShipping(state: StateCheckoutTransaction): boolean;
//   getIsPickup(state: StateCheckoutTransaction): boolean;
//   getStore(state: StateCheckoutTransaction): null | any;
//   getCourier(state: StateCheckoutTransaction): null | any;
//   getMonthlyPlans(state: StateCheckoutTransaction): Array<any>;
//   getMonthlyPaymentOptions(state: StateCheckoutTransaction): Array<any>;
//   getHasMonthlyPayment(state: StateCheckoutTransaction): boolean;
//   getHasShippingInsurance(state: StateCheckoutTransaction): boolean;
//   getActivePaymentConfig(state: StateCheckoutTransaction): IPaymentMethod | null;
//   getPaymentTokenizableTemporaly(state: StateCheckoutTransaction): BankCard[] | null;
//   getPaymentTokenizableTemporalyByMethodPayment(state: StateCheckoutTransaction): (code: string) => BankCard[];
//   getDeviceSessionId(state: StateCheckoutTransaction): string;
//   getTrackingId(state: StateCheckoutTransaction): string;
//   getSteps(state: StateCheckoutTransaction): Array<StepCheckout>;
//   getStep(state: StateCheckoutTransaction): string;
//   getIndexStepByCode (state: StateCheckoutTransaction): (code: string) => number;
//   getActiveStep(state: StateCheckoutTransaction): StepCheckout | null;
//   getNextStep(state: StateCheckoutTransaction, getters: GetterCheckout): StepCheckout | null;
//   getPrevStep(state: StateCheckoutTransaction, getters: GetterCheckout): StepCheckout | null;
//   isActiveToken(state: StateCheckoutTransaction): boolean;
//   isValidCVC(state: StateCheckoutTransaction, getters: GetterCheckout): boolean;
//   isValidPayment(state: StateCheckoutTransaction, getters: GetterCheckout): boolean;
//   isValidShipment(state: StateCheckoutTransaction) : boolean;
//   isValidMonthlyPayment(state: StateCheckoutTransaction) : boolean;
//   isValidReview(state: StateCheckoutTransaction, getters: GetterCheckout): boolean;
//   getPickupPerson(state: StateCheckoutTransaction): IPickupPerson;
//   getPickupPersonName(state: StateCheckoutTransaction): string;
//   getPickupPersonLastName(state: StateCheckoutTransaction): string;
//   getPickupPersonMotherLastName(state: StateCheckoutTransaction): string;
//   getPickupPersonTelephone(state: StateCheckoutTransaction): string;
//   getIsLoading(state: StateCheckoutTransaction) : boolean;
//   getIsSavingTransaction(state: StateCheckoutTransaction): boolean;
//   getIsLastStep(state: StateCheckoutTransaction, getters: GetterCheckout): boolean;
//   getAcceptTerms(state: StateCheckoutTransaction): boolean;
//   getAcceptShippingConditions(state: StateCheckoutTransaction): boolean;
//   getErrorMessage(state: StateCheckoutTransaction): string;
//   getCvcValidate(state: StateCheckoutTransaction): string;
// }

const state = () => defaultCheckoutTransactionInit;

// mutations
const mutations = {
  setPaymentMethods(
    state: StateCheckoutTransaction,
    paymentMethods: Array<IPaymentMethod>,
  ) {
    state.paymentMethods = paymentMethods;
  },
  setPaymentMethodCode(
    state: StateCheckoutTransaction,
    paymentMethodCode: string,
  ) {
    state.paymentMethodCode = paymentMethodCode;
    state.expiresTokenizable = null;
  },
  setPaymentTokenizable(
    state: StateCheckoutTransaction,
    paymentTokenizable: string,
  ) {
    state.paymentTokenizable = paymentTokenizable;
  },
  setExpiresTokenizable(
    state: StateCheckoutTransaction,
    expiresTokenizable: number,
  ) {
    state.expiresTokenizable = moment().add(expiresTokenizable, "seconds");
  },
  setStep(state: StateCheckoutTransaction, step: string) {
    state.step = step;
    state.loading = false;
  },
  setCustomerAddress(state: StateCheckoutTransaction, customerAddress: any) {
    state.customerAddress = customerAddress;
  },
  setBillingCustomerAddress(
    state: StateCheckoutTransaction,
    customerAddress: any,
  ) {
    state.billingCustomerAddress = customerAddress;
  },
  setRequiredBilling(
    state: StateCheckoutTransaction,
    requiredBilling: boolean,
  ) {
    state.requiredBilling = requiredBilling;
  },
  setIsShipping(state: StateCheckoutTransaction) {
    state.isShipping = true;
    state.store = null;
  },
  setIsPickup(state: StateCheckoutTransaction) {
    state.isShipping = false;
    state.customerAddress = null;
    state.courier = null;
  },
  setStore(state: StateCheckoutTransaction, store: any) {
    state.store = store;
  },
  setCourier(state: StateCheckoutTransaction, courier: any) {
    state.courier = courier;
  },
  setMonthlyPlans(
    state: StateCheckoutTransaction,
    monthlyPlans: Array<number>,
  ) {
    state.monthlyPlans = monthlyPlans;
  },
  setMonthlyPlansByIndex(
    state: StateCheckoutTransaction,
    item: { index: number; value: number },
  ) {
    state.monthlyPlans[item.index] = item.value;
  },
  setHasMonthlyPayment(
    state: StateCheckoutTransaction,
    hasMonthlyPayment: boolean,
  ) {
    state.hasMonthlyPayment = hasMonthlyPayment;
  },
  setHasShippingInsurance(
    state: StateCheckoutTransaction,
    hasShippingInsurance: boolean,
  ) {
    state.hasShippingInsurance = hasShippingInsurance;
  },
  toggleHasShippingInsurance(state: StateCheckoutTransaction) {
    state.hasShippingInsurance = !state.hasShippingInsurance;
  },
  setIsCompleted(state: StateCheckoutTransaction) {
    const index = state.steps.findIndex((item: StepCheckout) => {
      return item.code == state.step;
    });
    if (index >= 0 && state.steps[index]) {
      state.steps[index].isCompleted = true;
    }
  },
  setPickupPersonName(state: StateCheckoutTransaction, name: string) {
    state.pickupPerson.name = name;
  },
  setPickupPersonLastName(state: StateCheckoutTransaction, lastName: string) {
    state.pickupPerson.lastName = lastName;
  },
  setPickupPersonMotherLastName(
    state: StateCheckoutTransaction,
    motherLastName: string,
  ) {
    state.pickupPerson.motherLastName = motherLastName;
  },
  setPickupPersonTelephone(state: StateCheckoutTransaction, telephone: string) {
    state.pickupPerson.telephone = telephone;
  },
  setAcceptTerms(state: StateCheckoutTransaction, acceptTerms: boolean) {
    state.acceptTerms = acceptTerms;
  },
  setAcceptShippingConditions(
    state: StateCheckoutTransaction,
    acceptShippingConditions: boolean,
  ) {
    state.acceptShippingConditions = acceptShippingConditions;
  },
  setAcceptPickupConditions(
    state: StateCheckoutTransaction,
    acceptPickupConditions: boolean,
  ) {
    state.acceptPickupConditions = acceptPickupConditions;
  },
  toggleAcceptTerms(state: StateCheckoutTransaction) {
    state.acceptTerms = !state.acceptTerms;
  },
  toggleAcceptShippingConditions(state: StateCheckoutTransaction) {
    state.acceptShippingConditions = !state.acceptShippingConditions;
  },
  toggleAcceptPickupConditions(state: StateCheckoutTransaction) {
    state.acceptPickupConditions = !state.acceptPickupConditions;
  },
  reset(state: StateCheckoutTransaction) {
    state.paymentMethodCode = null;
    state.paymentMethods = [];
    // state.paymentTokenizable = null;
    state.paymentMethods = [];
    state.isShipping = null;
    state.requiredBilling = false;
    state.customerAddress = null;
    state.billingCustomerAddress = null;
    state.store = null;
    state.pickupPerson = {
      name: "",
      lastName: "",
      motherLastName: "",
      telephone: "",
    };
    state.courier = null;
    state.monthlyPlans = [];
    state.monthlyPaymentOptions = [];
    state.hasMonthlyPayment = false;
    state.hasShippingInsurance = true;
    state.step = "payment";
    state.steps.forEach((step: StepCheckout) => {
      step.isCompleted = false;
      step.show = true;
    });
    state.acceptTerms = false;
    state.acceptShippingConditions = false;
    state.acceptPickupConditions = false;
    state.errorMessage = "";
    state.cvcValidate = "";
    state.paymentTokenizableTemporaly = [];
    // state.deviceSessionId = "";
    // state.trackingId = "";
  },
  resetPayment(state: StateCheckoutTransaction) {
    state.paymentMethodCode = null;
    state.paymentTokenizable = null;
    state.courier = null;
    const step = state.steps.find((step: StepCheckout) => {
      return step.code == "payment";
    });
    if (step) {
      step.isCompleted = false;
    }
  },
  resetShipping(state: StateCheckoutTransaction) {
    state.isShipping = null;
    state.customerAddress = null;
    state.store = null;
    state.pickupPerson = {
      name: "",
      lastName: "",
      motherLastName: "",
      telephone: "",
    };
    state.courier = null;
    state.hasShippingInsurance = true;
    const step = state.steps.find((step: StepCheckout) => {
      return step.code == "shipping";
    });
    if (step) {
      step.isCompleted = false;
    }
  },
  resetMonthlyPayment(state: StateCheckoutTransaction) {
    state.monthlyPlans = [];
    state.monthlyPaymentOptions = [];
    state.hasMonthlyPayment = false;
    const step = state.steps.find((step: StepCheckout) => {
      return step.code == "monthly-payment";
    });
    if (step) {
      step.isCompleted = false;
    }
  },
  setIsLoading(state: StateCheckoutTransaction, loading: boolean) {
    state.loading = loading;
  },
  setIsSavingTransaction(
    state: StateCheckoutTransaction,
    isSavingTransaction: boolean,
  ) {
    state.isSavingTransaction = isSavingTransaction;
  },
  setErrorMessage(state: StateCheckoutTransaction, errorMessage: string) {
    state.errorMessage = errorMessage;
  },
  setCvcValidate(state: StateCheckoutTransaction, cvcValidate: string) {
    state.cvcValidate = cvcValidate;
  },
  setPaymentTokenizableTemporaly(
    state: StateCheckoutTransaction,
    paymentTokenizableTemporaly: BankCard[],
  ) {
    state.paymentTokenizableTemporaly = paymentTokenizableTemporaly;
  },
  addPaymentTokenizableTemporaly(
    state: StateCheckoutTransaction,
    paymentTokenizableTemporaly: BankCard,
  ) {
    paymentTokenizableTemporaly.creation_date = moment().format();
    state.paymentTokenizableTemporaly.push(paymentTokenizableTemporaly);
  },
  removePaymentTokenizableTemporaly(
    state: StateCheckoutTransaction,
    paymentTokenizableTemporalyId: string,
  ) {
    state.paymentTokenizableTemporaly =
      state.paymentTokenizableTemporaly.filter((card: BankCard) => {
        return paymentTokenizableTemporalyId != card.id;
      });
  },
  removeOldPaymentTokenizableTemporaly(state: StateCheckoutTransaction) {
    state.paymentTokenizableTemporaly =
      state.paymentTokenizableTemporaly.filter((card: BankCard) => {
        // Parsear la fecha en string
        const creationDate = moment(card.creation_date);
        const currentDate = moment();

        // Diferencia en horas
        const diffInHours = currentDate.diff(creationDate, "hours");

        return diffInHours < 3;
      });
  },
  setDeviceSessionId(state: StateCheckoutTransaction, deviceSessionId: string) {
    state.deviceSessionId = deviceSessionId;
  },
  setTrackingId(state: StateCheckoutTransaction, trackingId: string) {
    state.trackingId = trackingId;
  },
  setTransaction(state: StateCheckoutTransaction, transactionId: string) {
    state.transactionId = transactionId;
  },
};

const getters = {
  getPaymentMethodCode(state: StateCheckoutTransaction) {
    return state.paymentMethodCode;
  },
  getPaymentTokenizable(state: StateCheckoutTransaction) {
    return state.paymentTokenizable;
  },
  getExpiresTokenizable(state: StateCheckoutTransaction) {
    return state.expiresTokenizable;
  },
  getPaymentMethod(state: StateCheckoutTransaction) {
    if (state.paymentMethodCode) {
      const methodPayment = state.paymentMethods.find(
        (item: IPaymentMethod) => {
          return item.code == state.paymentMethodCode;
        },
      );
      return methodPayment ? methodPayment : null;
    }
    return null;
  },
  getSelectedPaymentTokenizable(state: StateCheckoutTransaction) {
    if (state.paymentMethodCode && state.paymentTokenizable) {
      const methodPayment = state.paymentMethods.find(
        (item: IPaymentMethod) => {
          return item.code == state.paymentMethodCode;
        },
      );
      if (methodPayment) {
        const paymentTokenizableTemp = state.paymentTokenizableTemporaly.find(
          (item: BankCard) => {
            return (
              item.id == state.paymentTokenizable &&
              item.payment_method_code == state.paymentMethodCode
            );
          },
        );
        if (paymentTokenizableTemp != undefined) {
          return paymentTokenizableTemp;
        }

        const paymentTokenizable = methodPayment.tokenizables.find(
          (item: BankCard) => {
            return item.id == state.paymentTokenizable;
          },
        );
        return paymentTokenizable ? paymentTokenizable : null;
      }
    }
    return null;
  },
  getPaymentMethods(state: StateCheckoutTransaction) {
    return state.paymentMethods;
  },
  getCustomerAddress(state: StateCheckoutTransaction) {
    return state.customerAddress;
  },
  getBillingCustomerAddress(state: StateCheckoutTransaction) {
    return state.billingCustomerAddress;
  },
  getRequiredBilling(state: StateCheckoutTransaction) {
    return state.requiredBilling;
  },
  getIsShipping(state: StateCheckoutTransaction) {
    return state.isShipping;
  },
  getIsPickup(state: StateCheckoutTransaction) {
    return state.isShipping === false;
  },
  getStore(state: StateCheckoutTransaction) {
    return state.store;
  },
  getCourier(state: StateCheckoutTransaction) {
    return state.courier;
  },
  getMonthlyPlans(state: StateCheckoutTransaction) {
    return state.monthlyPlans;
  },
  getMonthlyPaymentOptions(state: StateCheckoutTransaction) {
    return state.monthlyPaymentOptions;
  },
  getHasMonthlyPayment(state: StateCheckoutTransaction) {
    return state.hasMonthlyPayment;
  },
  getHasShippingInsurance(state: StateCheckoutTransaction) {
    return state.hasShippingInsurance;
  },
  getActivePaymentConfig(state: StateCheckoutTransaction) {
    const paymentMethod = state.paymentMethods.find((item: IPaymentMethod) => {
      return item.code == state.paymentMethodCode;
    });
    return paymentMethod ? paymentMethod : null;
  },
  getPaymentTokenizableTemporaly(state: StateCheckoutTransaction) {
    return state.paymentTokenizableTemporaly;
  },
  getPaymentTokenizableTemporalyByMethodPayment:
    (state: StateCheckoutTransaction) => (code: string) => {
      return state.paymentTokenizableTemporaly.filter((card: BankCard) => {
        return card.payment_method_code == code;
      });
    },
  getDeviceSessionId(state: StateCheckoutTransaction) {
    return state.deviceSessionId;
  },
  getTrackingId(state: StateCheckoutTransaction) {
    return state.trackingId;
  },
  getSteps: (state: StateCheckoutTransaction) => {
    if (state.steps) {
      return state.steps
        .filter((item: StepCheckout) => {
          return item.show;
        })
        .sort((a, b) => a.step - b.step);
    }
    return [];
  },
  getStep(state: StateCheckoutTransaction) {
    return state.step;
  },
  getIndexStepByCode: (state: StateCheckoutTransaction) => (code: string) => {
    return state.steps.findIndex((item: StepCheckout) => {
      return item.code == code;
    });
  },
  getActiveStep(state: StateCheckoutTransaction) {
    const step = state.steps.find((item: StepCheckout) => {
      return item.code == state.step;
    });

    return step ? step : null;
  },
  getNextStep(state: StateCheckoutTransaction, getters: any) {
    const steps = getters.getSteps;
    const index = steps.findIndex((item: StepCheckout) => {
      return item.code == state.step;
    });
    if (
      steps.length > index + 1 &&
      steps[index + 1] &&
      steps[index + 1].code == "monthly-payment" &&
      !state.hasMonthlyPayment
    ) {
      if (steps.length > index + 2) {
        return steps[index + 2];
      }
    }
    if (steps.length > index + 1) {
      return steps[index + 1];
    }
    return null;
  },
  getPrevStep(state: StateCheckoutTransaction, getters: any) {
    const steps: Array<StepCheckout> = getters.getSteps;
    const index = steps.findIndex((item: StepCheckout) => {
      return item.code == state.step;
    });
    if (
      0 <= index - 2 &&
      steps[index - 1]?.code == "monthly-payment" &&
      !state.hasMonthlyPayment
    ) {
      if (steps.length >= index - 2) {
        return steps[index - 2];
      }
    }
    if (0 <= index - 1) {
      return steps[index - 1];
    }
    return null;
  },
  isActiveToken(state: StateCheckoutTransaction) {
    if (state.expiresTokenizable == null) {
      return true;
    }
    if (state.expiresTokenizable) {
      return (
        moment().isAfter(state.expiresTokenizable) && state.paymentTokenizable
      );
    }
  },
  isValidCVC(state: StateCheckoutTransaction, getters: any) {
    const creationDate = getters.getSelectedPaymentTokenizable
      ? getters.getSelectedPaymentTokenizable?.payload?.creation_date
      : null;
    const cvc = getters.getSelectedPaymentTokenizable
      ? getters.getSelectedPaymentTokenizable?.payload?.cvc
      : null;
    if (getters.getSelectedPaymentTokenizable) {
      if (
        getters.getSelectedPaymentTokenizable?.payload?.type_resource ==
          "token" &&
        (state.paymentMethodCode == "paypal_card_v2" ||
          state.paymentMethodCode == "mercado_pago_card")
      ) {
        return true;
      }
      if (!creationDate || creationDate == "" || cvc == "") {
        return false;
      }
      const diffMinutes = moment().diff(moment(creationDate), "minutes");
      if (diffMinutes <= 10) {
        return true;
      }
    }
    return false;
  },
  isValidPayment(state: StateCheckoutTransaction, getters: any) {
    state.errorMessage = "";
    const activePaymentMethod = getters.getActivePaymentConfig;
    if (state.paymentMethodCode !== null && activePaymentMethod) {
      if (activePaymentMethod.tokenizer && state.paymentTokenizable === null) {
        if (state.paymentMethodCode.includes("card")) {
          state.errorMessage = "Por favor, selecciona tu tarjeta.";
        } else {
          state.errorMessage = "Por favor, inicia sesión.";
        }
        return false;
      }
      return true;
    }
    state.errorMessage = "Por favor, selecciona tu método de pago.";
    return false;
  },
  isValidShipment(state: StateCheckoutTransaction) {
    state.errorMessage = "";
    if (state.isShipping == null) {
      state.errorMessage =
        "Por favor, selecciona si deseas envío o recolección para tu pedido.";
    } else if (state.isShipping) {
      if (state.customerAddress !== null && state.courier !== null) {
        return true;
      } else {
        state.errorMessage = "Por favor, selecciona ";
        if (state.customerAddress == null) {
          state.errorMessage += "tu dirección de envío";
        }
        if (state.customerAddress == null && state.courier == null) {
          state.errorMessage += " y ";
        }
        if (state.courier == null) {
          state.errorMessage += "la paquetería que deseas";
        }
        state.errorMessage += ".";
      }
    } else if (state.isShipping === false) {
      if (state.store != null) {
        return true;
      } else {
        state.errorMessage += "Por favor, selecciona la tienda deseada.";
      }
    }
    return false;
  },
  isValidMonthlyPayment(state: StateCheckoutTransaction) {
    state.errorMessage = "";
    if (
      state.hasMonthlyPayment &&
      state.monthlyPlans.length > 0 &&
      state.monthlyPlans.filter((item: number | null) => {
        return item == null;
      }).length == 0
    ) {
      return true;
    }
    if (!state.hasMonthlyPayment) {
      state.errorMessage += "Por favor, selecciona la mensualidad deseada.";
      return false;
    }
    return false;
  },
  isValidReview(state: StateCheckoutTransaction, getters: any) {
    state.errorMessage = "";
    const activePaymentMethod = getters.getActivePaymentConfig;
    const regex = /^\d{3,4}$/;
    if (state.requiredBilling && state.billingCustomerAddress == null) {
      state.errorMessage += "Por favor, selecciona una dirección de facutación";
      return false;
    }

    if (
      activePaymentMethod &&
      activePaymentMethod.secure_code_required &&
      !getters.isValidCVC
    ) {
      if (state.cvcValidate && regex.test(state.cvcValidate)) {
        return true;
      } else {
        state.errorMessage +=
          "Por favor, ingresa un código de seguridad válido.";
        return false;
      }
    }

    state.errorMessage = "Errr";
    return true;
  },
  getPickupPerson(state: StateCheckoutTransaction) {
    return state.pickupPerson;
  },
  getPickupPersonName(state: StateCheckoutTransaction) {
    return state.pickupPerson.name;
  },
  getPickupPersonLastName(state: StateCheckoutTransaction) {
    return state.pickupPerson.lastName;
  },
  getPickupPersonMotherLastName(state: StateCheckoutTransaction) {
    return state.pickupPerson.motherLastName;
  },
  getPickupPersonTelephone(state: StateCheckoutTransaction) {
    return state.pickupPerson.telephone;
  },
  getIsLoading(state: StateCheckoutTransaction) {
    return state.loading;
  },
  getIsSavingTransaction(state: StateCheckoutTransaction) {
    return state.isSavingTransaction;
  },
  getIsLastStep(state: StateCheckoutTransaction, getters: any) {
    const steps: Array<StepCheckout> = getters.getSteps;
    const index = steps.findIndex((item: StepCheckout) => {
      return item.code == state.step;
    });
    if (index == steps.length - 1) {
      return true;
    }
    return false;
  },
  getAcceptTerms(state: StateCheckoutTransaction) {
    return state.acceptTerms;
  },
  getAcceptShippingConditions(state: StateCheckoutTransaction) {
    return state.acceptShippingConditions;
  },
  getAcceptPickupConditions(state: StateCheckoutTransaction) {
    return state.acceptPickupConditions;
  },
  getErrorMessage(state: StateCheckoutTransaction) {
    return state.errorMessage;
  },
  getCvcValidate(state: StateCheckoutTransaction) {
    return state.cvcValidate;
  },
  getTransactionId(state: StateCheckoutTransaction) {
    return state.transactionId;
  },
};

const actions: ActionTree<StateCheckoutTransaction, unknown> = {
  async storeShipping({ commit, dispatch }) {
    commit("setIsLoading", true);
    const { ShippingService } = await import("@/services/ShippingService");
    const shippingService = new ShippingService();
    shippingService
      .storeShipping()
      .then((response: any) => {
        if (response) {
          const data: any = dataFormatter.deserialize(response);
          commit("transaction/setCartFormatDB", data, { root: true });
          dispatch("nextStep");
        } else {
          commit("transaction/resetCart", { root: true });
        }
        commit("setIsLoading", false);
      })
      .catch(function (reason: AxiosError) {
        console.log(reason);
        commit("setIsLoading", false);

        showErrors(reason, `Ocurrio un error al guardar el envío`);
      });
  },
  async storePayment({ state, commit, dispatch, getters }) {
    const { PaymentMethodService } = await import(
      "@/services/PaymentMethodService"
    );
    const paymentMethodService = new PaymentMethodService();
    const seletedPlans: Array<number> = [];
    if (getters.isValidPayment && state.paymentMethodCode) {
      commit("setIsLoading", true);
      paymentMethodService
        .getMonthlyPayment(state.paymentMethodCode, state.paymentTokenizable)
        .then((response: any) => {
          if (response.meta) {
            let hasMonth = false;
            if (
              response.meta.monthly_payment_options &&
              response.meta.monthly_payment_options.length > 1
            ) {
              hasMonth = true;
            } else if (response.meta.monthly_payment_options) {
              response.meta.monthly_payment_options.forEach(
                (element: { max_months: number }) => {
                  if (element.max_months > 1) {
                    hasMonth = true;
                  } else {
                    // seletedPlans.push(0);
                  }
                },
              );
            }
            commit("resetMonthlyPayment");
            hasMonth = true;
            commit("setHasMonthlyPayment", hasMonth);
            const stepIndex = getters.getIndexStepByCode("monthly-payment");
            if (stepIndex >= 0 && state.steps[stepIndex]) {
              state.steps[stepIndex].show = hasMonth;
            }
            if (!hasMonth) {
              commit("setMonthlyPlans", seletedPlans);
              dispatch("storeMonthlyPayment");
            } else {
              dispatch("nextStep");
            }
          }
          commit("setIsLoading", false);
        })
        .catch(function (reason: AxiosError) {
          console.log(reason);
          commit("setIsLoading", false);

          showErrors(reason, `Ocurrio un error al guardar el método de pago`);
        });
    }
  },
  async storeMonthlyPayment({ commit, dispatch, getters }) {
    commit("setIsLoading", true);
    const { PaymentMethodService } = await import(
      "@/services/PaymentMethodService"
    );
    const selectedPlans = getters.getMonthlyPlans;
    if (selectedPlans.length > 0) {
      const paymentMethodService = new PaymentMethodService();
      paymentMethodService
        .storeMonthlyPayment()
        .then((response: any) => {
          if (response) {
            const data: any = dataFormatter.deserialize(response);
            commit("transaction/setCartFormatDB", data, { root: true });
            dispatch("nextStep");
          } else {
            commit("transaction/resetCart", { root: true });
          }
          commit("setIsLoading", false);
        })
        .catch(function (reason: AxiosError) {
          console.log(reason);
          commit("setIsLoading", false);
          showErrors(
            reason,
            `Ocurrio un error al guardar las mensualidades de pago`,
          );
        });
    } else {
      dispatch("nextStep");
    }
  },
  async nextStep({ commit, getters, dispatch }) {
    commit("setErrorMessage", "");
    if (getters.getIsLastStep) {
      if (typeof document === "object") {
        document.body.style.overflow = "hidden";
      }

      commit("setIsSavingTransaction", true);
      commit("setIsLoading", true);
      const { TransactionService } = await import(
        "@/services/TransactionService"
      );
      const transactionService = new TransactionService();

      transactionService
        .updateTransaction()
        .then((response: any) => {
          if (response) {
            const data = dataFormatter.deserialize(response.data);
            const transaction = new Transaction(data as ITransaction);

            dispatch("resetCheckout");
            commit("transaction/resetCart", null, { root: true });
            const router = useRouter();

            if (
              response?.data?.meta?.redirectTo &&
              response?.data?.meta?.redirectTo != ""
            ) {
              window.location = response.data.meta.redirectTo;
            } else if (
              transaction.payment_status ==
              TRANSACTIONS_ORDERS_PAYMENT_STATUS_PAYED
            ) {
              router.push({
                name: "success-payment",
                params: { transactionId: transaction.id },
              });
            } else if (
              transaction.payment_status ==
                TRANSACTIONS_ORDERS_PAYMENT_STATUS_PENDING ||
              transaction.payment_status ==
                TRANSACTIONS_ORDERS_PAYMENT_STATUS_PARTIALLY_PAYED
            ) {
              router.push({
                name: "pending-payment",
                params: { transactionId: transaction.id },
              });
            }
          }
        })
        .catch(function (reason: AxiosError) {
          dispatch("resetDeviceSessionId");
          showErrors(reason, `Ocurrio un error al procesar el pago`, 10000);
        })
        .finally(() => {
          commit("setIsLoading", false);
          commit("setIsSavingTransaction", false);
          if (typeof document === "object") {
            document.body.style.overflow = "auto";
          }
        });
    }
    if (getters.getNextStep) {
      eventBus.emit("next-step", {
        beforePath: getters.getActiveStep.to as RouteLocationRaw,
        nextPath: getters.getNextStep.to as RouteLocationRaw,
      });
      commit("setIsCompleted");
      commit("setStep", getters.getNextStep.code);
    }
  },
  resetCheckout({ commit, dispatch }, force: false) {
    commit("reset");
    if (force) {
      commit("setPaymentTokenizable", null);
      dispatch("resetDeviceSessionId");
    }
  },
  resetDeviceSessionId({ commit }) {
    let deviceSessionId = null;
    if (window.OpenPay) {
      window.OpenPay.setId(VITE_OPENPAY_MERCHANT_ID);
      window.OpenPay.setApiKey(VITE_OPENPAY_PUBLIC_API_KEY);
      window.OpenPay.setSandboxMode(VITE_OPENPAY_IS_SANDBOX);
      deviceSessionId = window.OpenPay.deviceData
        ? window.OpenPay.deviceData.setup()
        : null;
    }
    commit("setDeviceSessionId", deviceSessionId);

    // Create new trackingId
    loadScriptPaypal(true);
  },
  addPaymentTokenizable({ state }, paymentTokenizable: BankCard) {
    const paymentMethodCode = state.paymentMethodCode
      ? state.paymentMethodCode
      : paymentTokenizable.payment_method_code;
    if (paymentMethodCode) {
      const methodPayment: IPaymentMethod | undefined =
        state.paymentMethods.find((item: IPaymentMethod) => {
          return item.code == paymentMethodCode;
        });
      if (methodPayment) {
        methodPayment.tokenizables.push(paymentTokenizable);
      }
    }
  },
  removePaymentTokenizable({ state }, paymentTokenizable: BankCard) {
    const paymentMethodCode = state.paymentMethodCode
      ? state.paymentMethodCode
      : paymentTokenizable.payment_method_code;
    if (paymentMethodCode) {
      const methodPayment: IPaymentMethod | undefined =
        state.paymentMethods.find((item: IPaymentMethod) => {
          return item.code == paymentMethodCode;
        });
      if (methodPayment) {
        methodPayment.tokenizables = methodPayment.tokenizables.filter(
          (item: BankCard) => item.id != paymentTokenizable.id,
        );
      }
    }
  },
  verifyTokenizable({ state, commit }) {
    if (state.paymentTokenizable) {
      const tokenizesPaypal: IPaymentMethod | undefined =
        state.paymentMethods.find((item: IPaymentMethod) => {
          return item.code == "paypal_account";
        });
      if (tokenizesPaypal) {
        const paymentTokenizable = tokenizesPaypal.tokenizables.find(
          (item: BankCard) => {
            return item.id == state.paymentTokenizable;
          },
        );
        if (!paymentTokenizable) {
          commit("setPaymentTokenizable", null);
        }
      }
    }
  },
};

export const checkoutTransaction = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
